import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddLesson.module.scss";
import { CloseIcon } from "Assets/icons";
import { useGetLessonsListQuery } from "store/services/utility";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { successMessageToast } from "helpers/common";
import { useUpdateSupportStaffMutation } from "store/services/supportStaff";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useUpdateChatterProgramMutation } from "store/services/chatter/program";

const AddChatterLessonPop = ({ show, setShow, programDetails, programId }) => {

    const handlePopup = () => {

        setShow(!show);
        setValidation(null);
    };

    const [selectedLessons, setSelectedLessons] = useState([]);
    const [validation, setValidation] = useState(null)
    const [lessonOptionsList, setLessonOptionsList] = useState([]);

    const { data: lessonsList, isLoading } = useGetLessonsListQuery();
    const [updateProgram, { isLoading: updateProgramLoading }] = useUpdateChatterProgramMutation();

    const handleCheck = (checked, id) => {

        let list = [...selectedLessons];

        if (checked) {

            list.push(id);
            validation && setValidation(null);
        }
        else {

            const index = list.indexOf(id);
            if (index > -1) {
                delete list[index];
            };
        };

        setSelectedLessons(list.filter(Boolean));
    };

    const handleSubmit = async () => {

        try {
            if (selectedLessons.length == programDetails?.lessonProgramMapping?.length) {

                setValidation("Please select atleast 1 lesson");
                return;
            }

            handlePopup();

            const data = {
                lessons: selectedLessons,
                name: programDetails?.name,
                funding_source: programDetails?.funding_source,
                location: programDetails?.location,
                location_type: programDetails?.location_type,
                therapist_head1: programDetails?.therapist_head1,
                therapist_head2: programDetails?.therapist_head2,
                day: programDetails?.day,
                time: programDetails?.time?.slice(0, 5),
                status: programDetails?.status,
                start_date: programDetails?.start_date,
                end_date: programDetails?.end_date,
            };

            const result = await updateProgram({ data, programId })
            if (result?.error) return console.error("Error assigning lesson", result.error);

            successMessageToast(result?.data?.message);
        } catch (err) { console.error("Error assigning lesson", err); }
    };

    const handleSearch = (e) => {

        if (e.target.value.trim()) setLessonOptionsList(lessonOptionsList.filter(x => x.title.includes(e.target.value.trim())))
        else setLessonOptionsList(lessonsList)
    };

    useEffect(() => {

        if (lessonsList && lessonsList.length) setLessonOptionsList(lessonsList);
    }, [lessonsList]);

    useEffect(() => {

        if (programDetails) setSelectedLessons(programDetails?.lessonProgramMapping?.map(i => i.lesson_id) || []);

    }, [programDetails]);

    return (
        <>
            {updateProgramLoading ? <LoadingOverlay /> : null}
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 10, top: 0 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue">Lesson List</h6>

                    </div>
                    <Row>
                        <Col className="col-12 my-2">
                            <div className="iconWithText position-relative">
                                <span className="icn position-absolute" style={{ right: 10 }}>
                                    {searchIcn}
                                </span>
                                <input
                                    type="text"
                                    style={{ paddingRight: 30 }}
                                    placeholder="Search"
                                    className={`${styles.formControl} form-control`}
                                    onChange={handleSearch}
                                />
                            </div>
                        </Col>
                        <Col lg="12" className="my-2">
                            {
                                isLoading ? <LoadingIndicator /> : (
                                    <ul className="list-unstyled ps-0 mb-0">
                                        {
                                            lessonOptionsList?.map((item, index) => {
                                                return (
                                                    <li className="py-2" key={index}>
                                                        <div className="d-flex align-items-center justify-content-between gap-10">
                                                            <div className="left d-flex align-items-center gap-10">
                                                                <div className="content">
                                                                    <h6 className="m-0 fw-bold themeBlue">{item?.title}</h6>
                                                                </div>
                                                            </div>
                                                            <div className="right">
                                                                <input
                                                                    type="checkbox"
                                                                    style={{ height: 20, width: 20 }}
                                                                    className="form-check"
                                                                    checked={selectedLessons.includes(item.id)}
                                                                    onChange={e => handleCheck(e.target.checked, item.id)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                )
                            }
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-center flex-column">
                    <Button
                        type="submit"
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                        onClick={handleSubmit}
                    >
                        Save & Send Notification

                    </Button>
                    {validation ? <div className="error">{validation}</div> : null}
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default AddChatterLessonPop;



const searchIcn = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2621 15.5737L9.27139 10.8843C8.81306 11.2627 8.28598 11.5589 7.69014 11.7728C7.09431 11.9867 6.47793 12.0936 5.841 12.0936C4.27426 12.0936 2.9483 11.5512 1.86312 10.4663C0.777942 9.38144 0.235352 8.05579 0.235352 6.48936C0.235352 4.92308 0.777789 3.59697 1.86266 2.51103C2.94754 1.42524 4.27319 0.882339 5.83962 0.882339C7.4059 0.882339 8.73201 1.42493 9.81796 2.51011C10.9037 3.59529 11.4466 4.92125 11.4466 6.48799C11.4466 7.14264 11.3368 7.76788 11.1171 8.36372C10.8973 8.95955 10.604 9.47777 10.2373 9.91838L15.228 14.6076L14.2621 15.5737ZM5.841 10.7189C7.02212 10.7189 8.02251 10.309 8.84216 9.48915C9.66197 8.6695 10.0719 7.66911 10.0719 6.48799C10.0719 5.30686 9.66197 4.30647 8.84216 3.48682C8.02251 2.66701 7.02212 2.25711 5.841 2.25711C4.65987 2.25711 3.65948 2.66701 2.83983 3.48682C2.02003 4.30647 1.61012 5.30686 1.61012 6.48799C1.61012 7.66911 2.02003 8.6695 2.83983 9.48915C3.65948 10.309 4.65987 10.7189 5.841 10.7189Z" fill="#1C1B1F" />
</svg>


const serviceOptions = [
    {
        value: "",
        label: "All Services",
    },
    {
        value: "school",
        label: "School",
    },
    {
        value: "home_education",
        label: "Home Education",
    },
    {
        value: "chatter",
        label: "Chatter",
    },
    {
        value: "private",
        label: "Private",
    }
];